import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { ANY_ERROR } from '../../../../action/user_action_types';

import { fileUrl } from '../../../../config';
import SideBar from '../../common/sideBar';
import { history } from '../../../../history/history';
import HeaderAdminpanel from '../../common/HeaderAdminpanel';
import { calculateAmountAndTax } from '../../../../util/util';

class ViewCampaignComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignData: {}
    }
  };

  componentWillMount = () => {
    if (this.props.location.state && this.props.location.state.campaignData) {
      let { campaignData } = this.props.location.state;
      campaignData = calculateAmountAndTax(campaignData)
      this.setState({ campaignData });
    }
    else {
      history.push('/admin/salesuser');
    }
  }

  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  }

  //View campaign info
  render() {
    let { campaignData } = this.state;
    return (
      <div>
        <div className="dashboardContainer">
         <HeaderAdminpanel/>
          <div className="dashboardContainer-inner">
                <section id="sidebar">
                 <SideBar />          
                </section>
            <section id="dashboard-rightContainer" className="dashboard-manageSales brands-head">
              <div className="container-head">
                <div className="dashboard-breadcrumb">Campaign Management | Campaign List |
                  <span className="blue_camp"> Campaign Detail</span></div>
              </div>
              <div className="camplist_detail_wrapper">
                <div className="camplist_detail_left">
                  <div className="camplist_left_inner">
                    <div className="camplist_data">
                      <span className="camplist_head">Campaign Name</span>
                      <span className="camplist_name">{campaignData.name}</span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Brand Name</span>
                      <span className="camplist_name">{campaignData.brand}</span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Product Category</span>
                      <span className="camplist_name">{campaignData.product}</span>
                    </div>
                  </div>
                  <div className="camplist_left_inner">
                    <div className="camplist_data">
                      <span className="camplist_head">Package Type</span>
                      <span className="camplist_name">{campaignData.type}</span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Days Count</span>
                      <span className="camplist_name">{campaignData.days}</span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Start Date</span>
                      <span className="camplist_name">{moment(campaignData.startDate).format("DD/MM/YYYY")}</span>
                    </div>
                  </div>
                  <div className="camplist_left_inner">

                    <div className="camplist_data">
                      <span className="camplist_head">What is the objective of your campaign ?</span>
                      <span className="camplist_name">{campaignData.objective}</span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Sales Representative ID</span>
    <span className="camplist_name">{campaignData.sallerId}</span>
                    </div>
                    <div className="camplist_data">
                      <span className="camplist_head">Campaign ID</span>
                      <span className="camplist_name">{campaignData._id}</span>
                    </div>
                  </div>
                  {campaignData.fileName &&
                    <div className="camplist_data">
                      <span className="camplist_head">Uploaded Audio File</span>
                      <div className="camplist_name">
                        <div className="audio_inner"><div className="audio_img">
                          <img src="../../../assets/images/song.svg" />
                        </div><div className="file_desc">
                            <div className="file_name_size">
                              <div className="file_name">{campaignData.fileName}</div>
                              <span className="file_size">{campaignData.fileSize}</span></div>
                            <div className="downloadaudio_file">
                              <a href={`${campaignData.audioUrl}`} target= "__blank" download>Download</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="package_includes_wrapper">

                    {campaignData.fctperDay > 0 && campaignData.secondages > 0 &&
                      campaignData.additionalBenefits && campaignData.packageDiscountedCost &&
                      <div>
                        <h3>Package Includes :</h3>
                        <p>{campaignData.fctperDay} Seconds Per Day I {campaignData.secondages} Total Secondages I Total Cost: {campaignData.totalCost} INR
                        I Additional Benefit: {campaignData.additionalBenefits} %  I Discounted Cost: {campaignData.packageDiscountedCost} INR </p>
                      </div>
                    }
                    {campaignData.secondages > 0 && campaignData.additionalBenefits && campaignData.packageDiscountedCost && <div> <h3>Package Includes :</h3><p>{campaignData.secondages} Total Secondages I Total Cost: {campaignData.totalCost} INR
                        I Additional Benefit: {campaignData.additionalBenefits} %  I Discounted Cost: {campaignData.packageDiscountedCost} INR </p></div>}

                    { campaignData.nonFCT && campaignData.nonFCT[0] && (
                      <div>
                        <br/>
                        <h3> NON FCT Addons: </h3>{" "}
                        <p>{campaignData.nonFCT[0].description}</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="camplist_detail_right">
                  <div className="camplist_cost_card">

                    <h5>Campaign Cost</h5>
                    <ul className="camplist_cost_list">
                      {campaignData.actualpackageCost !== campaignData.packageCost &&  <li className="camplist_list_inner">
                        <div className="camplist_type">Actual Package Cost</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{campaignData.actualpackageCost}</span>
                        </div>
                      </li>}
                      {campaignData.couponDiscount > 0 && <li className="camplist_list_inner">
                        <div className="camplist_type coupon">Coupon Discount
                          {campaignData.couponPercentage > 0 &&
                            <span className="discount_desc">Coupon Applied Flat {campaignData.couponPercentage} % OFF</span>
                          }
                        </div>
                        <div className="camplist_rupee_symb">
                          <img src="../../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{campaignData.couponDiscount}</span>
                        </div>
                      </li>}
                      <li className="camplist_list_inner">
                        <div className="camplist_type">Package Cost</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{campaignData.packageCost}</span>
                        </div>
                      </li>
                      <li className="camplist_list_inner">
                        <div className="camplist_type">Taxes@18%</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{campaignData.taxes}</span>
                        </div>
                      </li>
                      {campaignData.audioTotalCost > 0 && <li className="camplist_list_inner">
                        <div className="camplist_type">Audio Cost</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{campaignData.audioTotalCost}</span>
                        </div>
                      </li>}
                      {campaignData.audioDiscount > 0 && <li className="camplist_list_inner">
                        <div className="camplist_type">Audio Discount</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{campaignData.audioDiscount}</span>
                        </div>
                      </li>}
                      
                      {campaignData.nonFCTCodeAmount && campaignData.nonFCTCodeAmount  > 0 && (
                      <li className="camplist_list_inner">
                        <div className="camplist_type">Non FCT Amount</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{campaignData.nonFCTCodeAmount}</span>
                        </div>
                      </li>
                    )}
                                        {campaignData.nonFCTCodeAmountTax && campaignData.nonFCTCodeAmountTax > 0 && (
                      <li className="camplist_list_inner">
                        <div className="camplist_type">Non FCT Tax @18</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../assets/images/rupee-indian.svg" />
                          <span className="cost_inner">{campaignData.nonFCTCodeAmountTax}</span>
                        </div>
                      </li>
                    )}
                      
                      <div className="totalcost">
                        <div className="camplist_type ">Total Cost</div>
                        <div className="camplist_rupee_symb">
                          <img src="../../../assets/images/rupee-indian_white.svg" />
                          <span className="cost_inner">{campaignData.totalCost}</span>
                        </div>
                      </div>
                    </ul>
                  </div>
                  <div className="view-btn_wrapper">
                    <button className="viewdetail_back"
                      onClick={() => this.goToRoute('salesuser', null, '/admin/salesuser')}>BACK</button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showError: error => dispatch({
      type: ANY_ERROR,
      payload: error
    })
  };
};
export default connect(null, mapDispatchToProps)(ViewCampaignComp);



// WEBPACK FOOTER //
// ./web/components/admin/users/salesUser/ViewCampaign.jsx